import { render, staticRenderFns } from "./CreateHeadcountSettings.vue?vue&type=template&id=35e74c1a&scoped=true"
import script from "./CreateHeadcountSettings.vue?vue&type=script&lang=js"
export * from "./CreateHeadcountSettings.vue?vue&type=script&lang=js"
import style0 from "./CreateHeadcountSettings.vue?vue&type=style&index=0&id=35e74c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e74c1a",
  null
  
)

export default component.exports